import React from 'react';

import DeliveryAdnOrdersContainer from './deliveryAndOrders/DeliveryAdnOrders.container';

const DeliveriesAndOrders = () => <DeliveryAdnOrdersContainer />;

export default DeliveriesAndOrders;
